<mat-paginator
  (page)="getUpdate($event)"
  [pageIndex]="page - 1"
  [length]="total"
  [pageSize]="30"
  [pageSizeOptions]="[30]"
>
</mat-paginator>
